import React from 'react';
import { motion } from 'framer-motion';
import { CheckCircle2, ShieldCheck, Zap, Download } from 'lucide-react';
export function Hero() {
  const scrollToPricing = () => {
    document.getElementById('pricing')?.scrollIntoView({
      behavior: 'smooth'
    });
  };
  return <section className="relative pt-12 pb-10 md:pt-32 md:pb-24 overflow-hidden" data-id="element-112">
      {/* Background elements */}
      <div className="absolute top-0 left-1/2 -translate-x-1/2 w-[800px] h-[800px] bg-brand-gold/5 rounded-full blur-3xl -z-10 pointer-events-none" data-id="element-113"></div>
      <div className="absolute top-0 right-0 w-96 h-96 bg-brand-red/10 rounded-full blur-3xl -z-10 pointer-events-none" data-id="element-114"></div>

      <div className="max-w-4xl mx-auto px-4 md:px-6 text-center" data-id="element-115">
        <motion.div initial={{
        opacity: 0,
        y: 20
      }} whileInView={{
        opacity: 1,
        y: 0
      }} viewport={{
        once: true
      }} className="inline-flex items-center gap-2 px-3 py-1 rounded-full bg-brand-panel border border-brand-border text-brand-gold text-[10px] md:text-xs font-semibold tracking-widest uppercase mb-6 md:mb-8" data-id="element-116">
          <span className="w-2 h-2 rounded-full bg-brand-red animate-pulse" data-id="element-117"></span>
          Guía Digital · Acceso Inmediato · Argentina
        </motion.div>

        <motion.h1 initial={{
        opacity: 0,
        y: 20
      }} whileInView={{
        opacity: 1,
        y: 0
      }} viewport={{
        once: true
      }} transition={{
        delay: 0.1
      }} className="text-3xl md:text-6xl lg:text-7xl font-serif font-bold text-white leading-tight mb-4 md:mb-6" data-id="element-118">
          ¿Querés que tu suegra te pida{' '}
          <span className="premium-gradient-text italic" data-id="element-119">la receta a vos?</span>
        </motion.h1>

        {/* Product mockup — full collection (al 70% en desktop) */}
        <div className="w-full md:w-[70%] mx-auto mb-5 md:mb-6 mt-1 md:mt-2" data-id="element-120">
          <motion.div initial={{
          opacity: 0,
          y: 40
        }} whileInView={{
          opacity: 1,
          y: 0
        }} viewport={{
          once: true
        }} transition={{
          duration: 0.7,
          delay: 0.15,
          ease: 'easeOut'
        }} className="relative rounded-xl md:rounded-2xl overflow-hidden border border-brand-gold/30 shadow-[0_0_40px_rgba(232,185,35,0.15)] md:shadow-[0_0_60px_rgba(232,185,35,0.15)]" data-id="element-121">
            <div className="absolute -inset-px rounded-xl md:rounded-2xl bg-gradient-to-b from-brand-gold/10 to-transparent pointer-events-none -z-10" data-id="element-122"></div>
            <img src="https://cdn.magicpatterns.com/uploads/hQqvUKrzbJ5vGnXoENmoSi/ChatGPT_Image_30_jun_2026,_06_50_05_p.m..png" alt="Operación Suegra — Colección Completa, 6 tomos. Recetas argentinas de verdad." width={1024} height={1536} className="w-full h-auto block" loading="eager" decoding="async" fetchPriority="high" data-id="element-123" />
          </motion.div>
          <p className="text-center text-xs md:text-sm text-gray-500 mt-2 md:mt-3" data-id="element-124">
            Colección Completa · 6 Tomos · Recetas argentinas de verdad
          </p>
        </div>

        <motion.p initial={{
        opacity: 0,
        y: 20
      }} whileInView={{
        opacity: 1,
        y: 0
      }} viewport={{
        once: true
      }} transition={{
        delay: 0.2
      }} className="text-lg md:text-2xl text-gray-300 font-light mb-3 md:mb-4" data-id="element-125">
          Operación Suegra™ · Chef de Barrio
        </motion.p>

        <motion.p initial={{
        opacity: 0,
        y: 20
      }} whileInView={{
        opacity: 1,
        y: 0
      }} viewport={{
        once: true
      }} transition={{
        delay: 0.3
      }} className="text-base md:text-xl text-gray-400 max-w-2xl mx-auto mb-8 md:mb-10 leading-relaxed" data-id="element-126">
          Cocinás bien en un fin de semana. Desde cero. Sin excusas. El sistema
          paso a paso para que cualquier persona sin experiencia cocine rico
          todos los días, ahorre en el supermercado y le gane a la suegra en la
          primera visita.
        </motion.p>

        <motion.div initial={{
        opacity: 0,
        y: 20
      }} whileInView={{
        opacity: 1,
        y: 0
      }} viewport={{
        once: true
      }} transition={{
        delay: 0.4
      }} className="flex flex-wrap justify-center gap-3 md:gap-8 mb-8 md:mb-12 text-xs md:text-sm text-gray-300" data-id="element-127">
          <div className="flex items-center gap-1.5 md:gap-2" data-id="element-128">
            <Download className="w-3.5 h-3.5 md:w-4 md:h-4 text-brand-gold" data-id="element-129" />
            <span data-id="element-130">PDF Digital</span>
          </div>
          <div className="flex items-center gap-1.5 md:gap-2" data-id="element-131">
            <Zap className="w-3.5 h-3.5 md:w-4 md:h-4 text-brand-gold" data-id="element-132" />
            <span data-id="element-133">Acceso en 5 min</span>
          </div>
          <div className="flex items-center gap-1.5 md:gap-2" data-id="element-134">
            <ShieldCheck className="w-3.5 h-3.5 md:w-4 md:h-4 text-brand-gold" data-id="element-135" />
            <span data-id="element-136">Garantía 7 días</span>
          </div>
          <div className="flex items-center gap-1.5 md:gap-2" data-id="element-137">
            <CheckCircle2 className="w-3.5 h-3.5 md:w-4 md:h-4 text-brand-gold" data-id="element-138" />
            <span data-id="element-139">Mercado Pago</span>
          </div>
        </motion.div>

        <motion.div initial={{
        opacity: 0,
        y: 20
      }} whileInView={{
        opacity: 1,
        y: 0
      }} viewport={{
        once: true
      }} transition={{
        delay: 0.5
      }} className="flex flex-col items-center" data-id="element-140">
          <motion.button whileHover={{
          scale: 1.02
        }} whileTap={{
          scale: 0.98
        }} onClick={scrollToPricing} className="bg-brand-red hover:bg-brand-redDark text-white text-base md:text-xl font-bold py-3.5 md:py-4 px-8 md:px-10 rounded-xl shadow-[0_0_30px_rgba(192,57,43,0.5)] transition-colors w-full sm:w-auto" data-id="element-141">
            💥 QUIERO MI OPERACIÓN SUEGRA YA
          </motion.button>
          <p className="mt-3 md:mt-4 text-xs md:text-sm text-gray-500 flex items-center gap-1.5 md:gap-2" data-id="element-142">
            <ShieldCheck className="w-3.5 h-3.5 md:w-4 md:h-4" data-id="element-143" />7 días de
            garantía total · Sin preguntas
          </p>
        </motion.div>
      </div>
    </section>;
}